import i18n from '@/i18n'

const deleteConfirmationWithLoading = {
    type: 'warning',
    title: i18n.t('notification.areYouSure'),
    confirmButtonText: i18n.t('notification.yes'),
    cancelButtonText: i18n.t('notification.no'),
    showCancelButton: true,
    showLoaderOnConfirm: true,
}

const bulkUpdateConfirmationWithLoading = {
    type: 'warning',
    title: i18n.t('notification.areYouSureBulkUpgrade'),
    confirmButtonText: i18n.t('notification.yes'),
    cancelButtonText: i18n.t('notification.no'),
    showCancelButton: true,
    showLoaderOnConfirm: true,
}

const getHtmlToSwalWithList = list => {
    // Make the <ul>
    let ul = document.createElement('ul')
    ul.className = 'list-group'

    if (list.length) {
        list.forEach(admin => {
            // Make the <li>
            let li = document.createElement('li')
            li.className = 'list-group-item'

            // Make the <div>
            let div = document.createElement('div')

            // Make the <h5>
            let h5 = document.createElement('h5')
            h5.className = 'mb-1'
            h5.innerHTML = admin.name

            // Make the <p>
            let p = document.createElement('p')
            p.className = 'mb-1'
            p.innerHTML = admin.email

            div.appendChild(h5)
            div.appendChild(p)

            li.appendChild(div)

            ul.appendChild(li)
        })
    }
    return ul
}

export {
    deleteConfirmationWithLoading,
    getHtmlToSwalWithList,
    bulkUpdateConfirmationWithLoading,
}
